/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IPublicSuburbanV1ValidateAddressRequest,
  TPublicSuburbanV1ValidateAddressModel,
  IMappers,
  TPublicSuburbanV1ValidateAddressResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IValidateAddressResponse } from '../../../entities/estimation_suburban/ValidateAddressResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicSuburbanV1ValidateAddressModel(
  parameters: IPublicSuburbanV1ValidateAddressRequest,
): TPublicSuburbanV1ValidateAddressModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'price-estimator',
    pathApi: '/suburban/v1/validate-address/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IPublicSuburbanV1ValidateAddressOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicSuburbanV1ValidateAddressRequest;
}

export async function fetchPublicSuburbanV1ValidateAddress<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicSuburbanV1ValidateAddressOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicSuburbanV1ValidateAddressResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicSuburbanV1ValidateAddressModel(parameters),
    config,
  )) as FetchResponse<TPublicSuburbanV1ValidateAddressResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IValidateAddressResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicSuburbanV1ValidateAddressResponse>;
}
